import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';
import { CanceledError } from 'axios';

const reviewScore = async (loading: Dispatch<SetStateAction<boolean>>, signal: AbortSignal) => {
  try {
    loading(true);
    const { data } = await http.get('/reviewScore', { signal });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const reviewScoreHistory = async (
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.get('/reviewScore/history', { signal });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const reviewScoreSplit = async (
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
) => {
  try {
    loading(true);
    const { data } = await http.get('/reviewScore/split', { signal });
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
};

const reviewScoreSplitCompany = async (
  platform: string,
  company: string,
  loading: Dispatch<SetStateAction<boolean>>,
  signal: AbortSignal
): Promise<{ scores: { score: number; count: number }[] }> => {
  try {
    loading(true);
    const { data } = await http.post(
      '/reviewScore/split',
      { platform, company },
      {
        signal,
      }
    );
    loading(false);
    return data;
  } catch (error) {
    if (error instanceof CanceledError) {
    } else {
      loading(false);
      console.error(error);
    }
  }
  return { scores: [] };
};

const WidgetService = {
  reviewScore,
  reviewScoreHistory,
  reviewScoreSplit,
  reviewScoreSplitCompany,
};

export default WidgetService;
